import { URLS } from "../../utilidades/dominios/urls";
import { OpcionCatalogo } from "../../compartido/ui/CampoAutocompletar";

// Catálogos públicos (sin token) para el formulario de registro.
async function obtener<T>(endpoint: string): Promise<T> {
  const respuesta = await fetch(URLS.URL_BASE + endpoint);
  if (!respuesta.ok) throw new Error("No se pudo cargar el catálogo");
  return respuesta.json();
}

export const CatalogosServicio = {
  /** Ciudades que tienen barrios cargados (para la residencia). */
  ciudadesConBarrios: () => obtener<OpcionCatalogo[]>(URLS.CATALOGO_CIUDADES + "?conBarrios=true"),
  barrios: (codCiudad: number) => obtener<OpcionCatalogo[]>(URLS.CATALOGO_BARRIOS(codCiudad)),
  /** Los 33 departamentos de Colombia; el código es el DANE de dos dígitos ("15"). */
  departamentos: () => obtener<OpcionCatalogo<string>[]>(URLS.CATALOGO_DEPARTAMENTOS),
  /** Municipios del departamento, con la capital de primera. */
  municipios: (codDepartamento: string) =>
    obtener<OpcionCatalogo[]>(URLS.CATALOGO_MUNICIPIOS(codDepartamento)),
};
